import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function classNames(...classNames: ClassValue[]) {
  return twMerge(clsx(classNames));
}
